import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    className as _$cn,
} from 'intact';
import {makeStyles} from './styles';
import kingvisionLogo from '../../../imgs/kingvision_logo.png';
import kingvisioinTitle from '../../../imgs/kingvisioin_title.png';
import {Button} from 'kpc';

var _$tmp0 = {
    'href': 'http://vision.ksyun.com/#/icon-reposition',
    'target': '_blank'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                _$ce(2, 'div', (
                    _$ce(2, 'img', null, 1, null, {
                        'src': kingvisionLogo,
                        'width': '307'
                    })
                ), 2, 'main-logo'),
                _$ce(2, 'div', (
                    _$ce(2, 'img', null, 1, null, {
                        'src': kingvisioinTitle,
                        'width': '163'
                    })
                ), 2, 'vis-title'),
                _$ce(2, 'div', '\n                专业的企业级设计资源，丰富的图片与icon定制平台。\n            ', 16, 'vis-description web-info'),
                _$ce(2, 'div', [
                    _$ce(2, 'div', '专业的企业级设计资源，', 16),
                    _$ce(2, 'div', '丰富的图片与icon定制平台。', 16)
                ], 4, 'vis-description h5-info'),
                _$ce(2, 'a', (
                    _$cc(Button, {
                        'className': 'visit-king-vision',
                        'type': 'primary',
                        'children': '访问KingVision'
                    })
                ), 2, null, _$tmp0)
            ], 4),
            _$ce(2, 'div', (
                _$ce(2, 'div', null, 1, 'king-vision-bg')
            ), 2)
        ], 4, 'king-vis-wrapper')
    ), 2, _$cn(makeStyles()));
};